import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireFeatureGate } from '~/utils/guards';

const CustomerConstraintsPage = lazy(
  () => import('~/features/subsidiary-configuration/pages/customer-constraints-page'),
);

export const Route = createFileRoute('/_authenticated/_tenant/subsidiary-preferences/constraints')({
  beforeLoad: requireFeatureGate('subsidiary_configuration'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <CustomerConstraintsPage />
    </Suspense>
  ),
});
